<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>{{ $route.params.id < 0 ? "Tambah" : "Ubah" }} Hak Akses</h2>

      <br />

      <div class="form-wrapper">
        <form @submit.prevent="save">
          <div class="form-group">
            <label>Nama</label>
            <input type="text" v-model="data.nama" />
          </div>

          <div class="table-wrapper">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Menu</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in dataMenu"
                  :key="index"
                  :class="item.selected ? 'active' : ''"
                  @click="toggleSelected($event, item)"
                >
                  <td>{{ ++index }}</td>
                  <td :class="item.id_parent ? 'child' : ''">
                    {{ item.menu }}
                  </td>
                  <td align="right">
                    <div
                      class="checkbox"
                      :class="{ active: item.selected }"
                    ></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-group button">
            <button type="submit" class="btn-fill" :disabled="loadingButton">
              Simpan
            </button>
            <button type="button" class="btn-outline" @click="back()">
              Kembali
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/Api";
export default {
  name: "HakAksesForm",
  components: {},
  data() {
    return {
      loading: false,
      loadingButton: false,
      dataMenu: [],
      data: {
        id: this.$route.params.id,
        id_toko: this.$toko.id,
      },
    };
  },
  methods: {
    loadMenu() {
      this.loading = true;
      api
        .get(
          "/v4/setting/user-akses?id=1" +
            "&id_toko=" +
            this.$toko.id +
            "&desktop=1"
        )
        .then((r) => {
          this.dataMenu = [];
          const menu = r.data.detail;

          const menuParent = menu.filter((k) => {
            return k.id_parent == null;
          });

          menuParent.forEach((item) => {
            const menuChildren = menu.filter((k) => {
              return k.id_parent == item.id_menu;
            });

            if (menuChildren.length > 0) {
              item.hasChildren = true;
              item.active = false;
              item.children = menuChildren;
            }
            item.selected = false;

            this.dataMenu.push(item);
          });

          const newDataMenu = [];
          this.dataMenu.forEach((item) => {
            newDataMenu.push(item);
            if (item.children) {
              item.children.forEach((child) => {
                newDataMenu.push(child);
              });
            }
          });

          this.dataMenu = newDataMenu;

          if (this.$route.params.id > 1) {
            api
              .get("/v4/setting/user-akses?id=" + this.$route.params.id)
              .then((r) => {
                r.data.detail.forEach((item) => {
                  const aksesMenu = newDataMenu.find(
                    (k) => k.id_menu == item.id_menu
                  );
                  aksesMenu.selected = true;
                });
                this.loading = false;
              });
          } else {
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },    
    toggleSelected(e, item) {
      item.selected = !item.selected;

      this.dataMenu
        .filter((k) => {
          return k.id_parent == item.id;
        })
        .forEach((k) => {
          k.selected = item.selected;
        });

      if (item.id_parent) {
        this.dataMenu.find((k) => {
          return k.id == item.id_parent;
        }).selected = item.selected;
      }
    },
    save() {
      let selected = [];
      this.dataMenu.forEach((item) => {
        if (item.selected) {
          selected.push(item);
        }
      });

      this.data.tipe = "DESKTOP";
      this.data.detail = selected;

      if (!this.data.nama) {
        this.$toast("Nama akses harus diisi ya");
        return;
      }

      this.loadingButton = true;

      api
        .post("/v4/setting/user-akses/save", this.data)
        .then((r) => {
          this.loadingButton = false;

          if (r.valid) {
            this.$router.go(-1);
          } else {
            this.$toast(r.message);
          }
        })
        .catch((e) => {
          this.loadingButton = false;
          this.$toast("Gagal menyimpan data");
        });
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    if (this.$route.params.id == 1) {
      this.back();
    } else {
      this.loadMenu();
    }
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .form-wrapper {
    margin-top: 30px;
    form {
      width: 450px;
      .form-group.button {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 15px;
      }
    }
  }

  .table-wrapper {
    height: calc(100vh - 380px);
    margin-bottom: 15px;
    tr.active {
      td {
        // background-color: var(--primary);
        color: var(--primary);
      }
    }
    td {
      &.child {
        padding-left: 20px !important;
      }
      .checkbox {
        width: 15px;
        height: 15px;
        border: 1px solid var(--primary);
        border-radius: 4px;
        &.active {
          background: var(--primary);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pengaturan/HakAksesForm.vue